module.exports = __webpack_public_path__ + "static/media/microcentrifuge_body.00868fd8.svg";